const FormatChange = ({ change }) => {
    if (change === null || change === undefined || change === 'N/A')
        return '-';

    // Convert to decimal if percentage string
    let numericValue;
    if (typeof change === 'string') {
        numericValue = parseFloat(change.replace('%', '').replace('+', '')) / 100;
    } else {
        numericValue = change; // Already in decimal form
    }

    const isPositive = numericValue >= 0;
    const absoluteValue = Math.abs(numericValue * 100).toFixed(2);

    return (
        <span className={isPositive ? 'positive' : 'negative'}> {isPositive ? '+' : '-'}{absoluteValue}% </span>
    );
};

export default FormatChange;